import { VERIFY_SECURITY_VALIDATION_TYPE } from '@redux/slice/portal-settings-slice';
import { clearSiteKey, resetSitekey } from '@redux/slice/turnstile-slice';
import { CF_RULES, MAX_ATTEMPT } from '@redux/constant/turnstile.constant';

export function getWidgetTypeValue() {
    return window.darkTheme ? 'dark' : 'light';
}

export function turnstileSkipLiteApp(isAllowTurnstileForLiteApp) {
    return isAllowTurnstileForLiteApp || !window.SPL_LiteApp.isLiteApp();
}

export function enabledTurnstile(isAllowTurnstileForLiteApp, verifySecurityValidation) {
    const skipLiteApp = turnstileSkipLiteApp(isAllowTurnstileForLiteApp);
    return (verifySecurityValidation || []).includes(VERIFY_SECURITY_VALIDATION_TYPE.CLOUDFLARE_TURNSTILE) && skipLiteApp;
}

export function checkTurnstileValidation(captchaToken, isAllowTurnstileForLiteApp, verifySecurityValidation, siteKey = null, turnstileReducer = null, modules = null) {
    // condition to disable submit button, if doesnt meet make it enable
    // 1. master switch got verify_security_validation: ['CLOUDFLARE_TURNSTILE'] in register group
    // 2. token is empty
    // 3. attempt check return false
    const verifySecurityValidationValue = enabledTurnstile(isAllowTurnstileForLiteApp, verifySecurityValidation);
    const maxAttemptsCheck = modules?.[CF_RULES]?.[MAX_ATTEMPT];
    return !captchaToken && !!verifySecurityValidationValue && !!siteKey && maxAttemptsCheck && !turnstileReducer?.attemptCheckShowTunrstile;
}

export function getSiteKey(dispatch, enabledTurnstile) {
    if (enabledTurnstile) {
        dispatch(clearSiteKey());
        dispatch(resetSitekey());
    }
}
